export function initLoginForm() {
  // shake login form gently upon incorrect login
  if ($('#login-form .alert.alert-danger.alert-dismissable').text().match(/Invalid Email or password/)) {
    $('#login-form .col').delay(250).effect("shake",{distance: 15, times: 3}, 750); // last number is speed in ms
  }

  // shake login form harder when account is about to be locked
  if ($('#login-form .alert.alert-danger.alert-dismissable').text().match(/You have one more attempt before your account is locked/)) {
    $('#login-form .col').delay(250).effect("shake",{distance: 30, times: 9}, 3000);
  }
}
